import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as i}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const d=t("sweden",i`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            static>
            <path
                d="M0 0H24V16H0V0Z"
                fill="#0052B4" />
            <path
                d="M9 0H6V6.4999H0V9.49987H6V15.9998H9V9.49987H24V6.4999H9V0Z"
                fill="#FFDA44" />
        </svg>
    `),e=i`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40026"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40026)">
            <g clip-path="url(#clip0_4915_40026)">
                <path
                    d="M-6.03516 0.5H29.9648V24.5003H-6.03516V0.5Z"
                    fill="#0052B4" />
                <path
                    d="M7.46484 0.5H2.96484V10.25H-6.03516V14.75H2.96484V24.4999H7.46484V14.75H29.9648V10.25H7.46484V0.5Z"
                    fill="#FFDA44" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40026">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-6.03516 0.5)" />
            </clipPath>
        </defs>
    </svg>
`,n=t("sweden_rounded",e),o=t("SEK",e);export{o as SEK,d as Sweden,n as SwedenRounded};
